/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClickerSession } from '../../models/clicker-session';
import { PaginatedResponse } from '../../models/paginated-response';

export interface ClickerSessionsControllerFindAll$Params {
  page?: number;
  limit?: number;
  status?: 'OPEN' | 'CLOSED';
  eventId?: string;
}

export function clickerSessionsControllerFindAll(http: HttpClient, rootUrl: string, params?: ClickerSessionsControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedResponse & {
'items'?: Array<ClickerSession>;
}>> {
  const rb = new RequestBuilder(rootUrl, clickerSessionsControllerFindAll.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('status', params.status, {});
    rb.query('eventId', params.eventId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedResponse & {
      'items'?: Array<ClickerSession>;
      }>;
    })
  );
}

clickerSessionsControllerFindAll.PATH = '/clicker/sessions';
